import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import moment from 'moment';
import config from '../../../../../../config';
import {
  calculateScheduleHoursAndMinutes,
  formatScheduleDateRange,
  formatScheduleTimeSummary,
  scheduleHasEnabledDays,
} from '../helpers/scheduleHelpers';
import WorkDayConflictIconWithTooltip from '../../../../../common/schedulesForm/workDayConflictIconWithTooltip';
import { t } from '../../../../../../modules/infra/i18n';

const ScheduleSummary = ({ scheduleSummary }) => {
  const totalWorkingTime = calculateScheduleHoursAndMinutes(scheduleSummary);

  return (
    <div className="c-schedule-summary" data-automation-id="schedule-summary">
      <span className="c-heading c-heading--lightgrey">{t('barber:schedule_summary.heading')}</span>
      <div className="c-schedule-summary__shops" data-automation-id="schedule-summary-shops">
        <div className="u-font-color-grey" display-if={!totalWorkingTime.hours && !totalWorkingTime.minutes}>
          {t('barber:schedule_summary.select_work_days')}
        </div>
        { scheduleSummary.map(summaryItem => (
          <div
            className="c-schedule-summary__shop"
            data-automation-id={`schedule-summary-shop-${summaryItem.shopId}`}
            display-if={!!summaryItem.startDate && scheduleHasEnabledDays(summaryItem)}
            key={summaryItem.shopId}
          >
            <div className="u-type--bold">{summaryItem.shopName}</div>
            <div className="u-font-color-grey u-fontsize-extrasmall">
              {formatScheduleDateRange(summaryItem.startDate, summaryItem.endDate)}
            </div>
            { summaryItem.workdays.map(weekdayItem => (
              <div
                display-if={weekdayItem.enabled}
                className={classNames('c-schedule-summary__shop__weekday', {
                  'c-schedule-summary__shop__weekday__conflict': weekdayItem.hasConflicts,
                })}
                key={weekdayItem.weekDay}
                data-automation-id={`summary-day-${weekdayItem.weekDay}`}
              >
                <div
                  className="c-schedule-summary__shop__weekday__item"
                >
                  <span>{moment().day(weekdayItem.weekDay).format(config.fullDayOfWeek)}</span>
                  <WorkDayConflictIconWithTooltip
                    dayConflicts={weekdayItem}
                    display-if={weekdayItem.hasConflicts}
                  />
                </div>
                <div className="u-type--uppercase">{`${weekdayItem.startTime} - ${weekdayItem.endTime}`}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="c-schedule-summary__total" data-automation-id="schedule-summary-total">
        <span>{t('barber:schedule_summary.total_working_hours')}</span>
        <span className="u-type--bold"> {formatScheduleTimeSummary(totalWorkingTime)}</span>
      </div>
    </div>
  );
};

ScheduleSummary.propTypes = {
  scheduleSummary: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ScheduleSummary;
